import { render, staticRenderFns } from "./FunctionAccessEdit.vue?vue&type=template&id=2a06bc2d"
import script from "./FunctionAccessEdit.vue?vue&type=script&lang=js"
export * from "./FunctionAccessEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports